import script from "./VisitPayModalNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitPayModalNew.vue?vue&type=script&setup=true&lang=js"

import "./VisitPayModalNew.vue?vue&type=style&index=0&id=638f29da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638f29da"]])

export default __exports__